import { bffRoutes } from '../utils/configuration';
import * as HttpStatus from 'http-status-codes';

const BFF_BASE_URL = window.__ENV__.BFF_URL;

export const checkStatus = (res) => {
  if (res.ok) {
    // res.status >= 200 && res.status < 300
    return res;
  } else {
    throw new Error(`fetch with status failed ${res.statusText}`);
  }
};

export const validateTransferToken = async (transferToken, businessUnit, formName) => {
  return await fetch(bffRoutes.getGBTokenValidate(), {
    mode: 'cors',
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: transferToken,
    },
    body: JSON.stringify({
      businessUnit,
      formName,
    }),
  })
    .then(checkStatus)
    .then((response) => response.json())
    .catch(() => HttpStatus.INTERNAL_SERVER_ERROR);
};

export const getAuth = () => window.sessionStorage.isAuthenticated;

export const removeAuth = () => window.sessionStorage.removeItem('isAuthenticated');

export const sendRequest = async (url) =>
  await fetch(url, {
    mode: 'cors',
    credentials: 'include',
    method: 'POST',
  });

/**
 * Exchanges a JWT for a transfer token
 * @param {string} jwt
 * @param {string} sessionCorrelationId
 */
export const GetTransferToken = async (jwt, sessionCorrelationId) => {
  return await fetch(`${BFF_BASE_URL}/transfer/v1/out`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'mli-session-correlation-id': sessionCorrelationId,
      'mli-correlation-id': sessionCorrelationId,
      'mli-channel': 'web',
    },
    body: JSON.stringify({
      tokens: {
        'gb-authorization': jwt,
      },
    }),
  });
};
